import { render, staticRenderFns } from "./BidderDetailsPage.vue?vue&type=template&id=dea782da&scoped=true&"
import script from "./BidderDetailsPage.vue?vue&type=script&lang=js&"
export * from "./BidderDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./BidderDetailsPage.vue?vue&type=style&index=0&id=dea782da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea782da",
  null
  
)

export default component.exports